<template>
  <!-- cleaned ok-->
  <div id="ficheViewer">
    
    <div id="zoneDiapo">
      <div id="back" @click="
        updateStateValue({ key: 'ficheOn', value: false });
        "></div>
      <lecteurDiapo v-if="ficheArray.marque"
        :racineName="`${ficheArray.marque?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ /g, '_')}-${ficheArray.uuid}-`"
        :listeDiapos="ficheArray[langue]?.diaposListeTotal"
        :resolution="resolution"
        :sectionActive="storeUrlArray.section"
        @images-loaded="onAllImagesLoaded"
      />
    </div>
    
    <div id="zoneInfos" ref="scrollable" class="scrollMinimal">
        <div class="content">
        <div v-if="ficheArray.marque">
          <h1 v-html="ficheArray.marque"></h1>
          <h3 style="color: var(--colorDark); margin-top: 0" v-if="ficheArray?.[langue]?.titre" v-html="ficheArray[langue]?.titre"></h3>

          <br>

          <div v-if="ficheArray?.[langue]?.sections" class="listeLien">
            <div class="chapitre" 
               :class="{ active: parseInt(storeUrlArray.section) === index }" 
               v-for="(item, index) in ficheArray[langue]?.sections" 
               :key="index"
               @click.prevent="parseInt(storeUrlArray.section) === index ? selectSection(0) : selectSection(index)">
              <h4
              :class="['picto', 'picto' + item.picto, { active: parseInt(storeUrlArray.section) === index }]"
              :style="parseInt(storeUrlArray.section) === index ? { backgroundImage: `url(interface/${item.picto}-active.svg)` } : { backgroundImage: `url(interface/${item.picto}.svg)` }"
              >{{ item.titre }}</h4>
            </div>
          </div>
          <p v-if="ficheArray?.[langue]?.sections?.[storeUrlArray.section]"
             v-html="ficheArray[langue]?.sections?.[storeUrlArray.section]?.pitch"></p>
          
          <div class="tags" v-if="storeUrlArray.section === 0">
            <h6 v-for="tag in tags" :key="tag">{{ tag }}</h6>
          </div>
        </div>    

        <div v-if="filteredLiensFicheUuids.length > 0">
          <h3>{{ translations.lienFiche[langue] }}</h3>
          <div id="zoneListeLiens">
            <h3 style="margin:6px">{{ ficheArray[langue]?.liensfiche?.name }}</h3>
            <div class="flexEnLigne">
              <h2
                class="bouttons"
                style="background-color: var(--colorLight);"
                v-for="(item, index) in filteredLiensFicheUuids"
                @click="updateStoreUrl({ tag: 'uuid', value: item })"
                :key="index"
              >
                {{ getIndexIdByUuid(item)?.marque || `erreur uuid: ${item}` }}
              </h2>
            </div>
          </div>
        </div>

        <div id="clickableElement">
         
            <btActions
              @click="switchPlaylist(ficheArray.uuid)"
              model="left"
              taille="normal"
              :label="translations.add_to_list[langue]"
              :picto="storeUrlArray.playlist.includes(ficheArray.uuid) ? 'circle-check-big.svg' : 'circle-plus.svg'"
            />
             <btActions
              @click="openContact()"
              model="left"
              taille="normal"
              :label="translations.contact[langue].toUpperCase()"
              picto="message-square-share.svg"
            />
        </div>
        </div>

    </div>
  
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import lecteurDiapo from './elements/lecteurDiapo.vue';
import btActions from './elements/btActions.vue'; 

export default {
  name: 'ficheViewer',
  props: {
    ficheArray: Object,
    resolution: String,
    langue: String,
    translations: Object,
  },
  components: {
    lecteurDiapo,
    btActions,
  },
  data() {
    return {
      tags: [],
      imagesLoaded: false,
    };
  },
  computed: {
    ...mapState(['storeUrlArray', 'storeSectionOn', 'storeEcran', 'showAll']),
    ...mapGetters(['getIndexIdByUuid']),
    filteredLiensFicheUuids() {
      const uuids = this.ficheArray?.[this.langue]?.liensfiche?.[0]?.uuid || [];
      if (this.showAll) return uuids;
      return uuids.filter(uuid => this.getIndexIdByUuid(uuid)?.visible === true);
    },
  },  
  mounted() {
    this.refreshFicheData();
    window.addEventListener('keydown', this.handleKeyboardNavigation);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyboardNavigation);
  },
  methods: {
    ...mapActions(['updateStateValue', 'switchPlaylist', 'updateStoreUrl']),
    openContact() {
      window.open('https://r-agency.fr/#contacts', '_blank');
    },

    onAllImagesLoaded() {
      console.log('Toutes les images sont chargées');
      this.imagesLoaded = true;
    },
    
    
    selectSection(index) {
      this.updateStateValue({ key: 'storeSectionOn', value: parseInt(index) });
      this.updateStoreUrl({ tag: 'section', value: parseInt(index) });
      this.refreshFicheData();
    },

    refreshFicheData() {
      this.tags = (this.ficheArray[this.langue].tags || '').split(',');
    },

    handleKeyboardNavigation(event) {
      if (event.key === 'ArrowUp') {
        this.selectSection(
          (this.storeUrlArray.section - 1 + this.ficheArray[this.langue].sections.length) %
            this.ficheArray[this.langue].sections.length
        );
      } else if (event.key === 'ArrowDown') {
        this.selectSection(
          (this.storeUrlArray.section + 1) % this.ficheArray[this.langue].sections.length
        );
      }
    },
  },
  watch: {
    langue() {
      this.refreshFicheData();
    },
    'storeUrlArray.uuid'() {
      console.log('storeUrlArray.uuid changed');
      this.imagesLoaded = false;
      this.refreshFicheData();
      // Scroll en haut de #zoneInfos
      this.$nextTick(() => {
        if (this.$refs.scrollable) {
          this.$refs.scrollable.scrollTop = 0;
        }
      });
    },
    ficheArray() {
      this.$nextTick(() => {
        if (this.$refs.scrollable) {
          // Mise à jour si nécessaire
        }
      });
    },
  }
};
</script>

<style scoped>
/* === STRUCTURE PRINCIPALE === */
#ficheViewer {
  min-height: var(--hauteur);
  overflow: hidden;
  width: auto !important;
  max-width: none !important;
  min-width: auto !important;
  color: var(--colorDark);
  display: flex;
  background: var(--colorWhite);
}

/* === BOUTON BACK === */
#back {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 30px;
  height: 30px;
  background-image: url('/public/interface/back.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 10;
}

#back:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

/* === ZONES PRINCIPALES === */
#zoneDiapo {
  aspect-ratio: 1/1 !important;
  position: relative;
  width: var(--hauteur);
  height: var(--hauteur);
}

#zoneInfos {
  font-size: 14px;
  max-width: min(var(--largeurMaxMobile), 100vw) !important;
  z-index: 1;
  
  overflow: auto;
}
.content{
  padding: var(--marge);
}
/* === CONTENU === */
#pitch {
  font-size: 12px;
}

h1 {
  margin: -6px 0 6px 0;
}

h3 {
  margin: 20px 0 0 0;
}



/* === LISTE DES LIENS === */
.listeLien {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.chapitre h4  {
  display: inline-block;
  cursor: pointer;
  border-radius: 20px;
  margin: 0 0 4px 0;
  padding: 6px 12px 6px 30px;
  color: var(--colorDark);
}

.chapitre h4:hover {
  background-color: var(--colorLight);
}

.chapitre h4.active {
  background-color: var(--colorDark);
  color: var(--colorWhite);
}

.chapitre h4 div {
  display: inline-block;
  padding: 4px 14px 4px 34px;
}

/* === PICTOS === */
.picto {
  background-repeat: no-repeat;
  background-size: 18px;
  background-position: 6px center;
  padding: 10px;
}

.pictodot {
  background-image: url('/public/interface/active.svg');
}

.picto.active.pictodot, 
.picto:hover.pictodot {
  background-image: url('/public/interface/fiche.svg');
}

.pictoFiche {
  background-image: url('/public/interface/fiche.svg');
}

/* === TAGS === */
.tags {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}


/* === LIENS FICHE === */
#zoneListeLiens {
  margin-top: 0px;
}

.lienFiche {
  display: inline-block;
  width: auto;
  min-width: 0;
  max-width: 100%;
  cursor: pointer;
}

/* === ACTIONS === */
#clickableElement {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  color: var(--colorDark);
  border-radius: 7px;
  margin-top: 20px;
}

.action {
  display: flex;
  flex-direction: row;
  text-align: left;
  align-items: center;
  cursor: pointer;
  width: auto;
  max-width: 150px;
}

.action img {
  height: 30px;
  padding-right: 10px;
}

/* === RESPONSIVE MOBILE === */
@media screen and (min-width: 1101px) {
  #back {
    display: none;
  }
}

@media screen and (max-width: 1100px) {
  #ficheViewer {
    width: 100vw;
    flex-direction: column;
  }
  #zoneInfos{
    padding-bottom: 20px !important;
  }
  #zoneDiapo {
    max-width: min(var(--largeurMaxMobile), 100vw) !important;
    max-height: min(var(--largeurMaxMobile), 100vw) !important;
  }
  #zoneListeLiens{
    margin-bottom: 10px;
  }
  #pitch {
    margin-bottom: 10px;
  }
  #letexte {
    width: calc(100% - var(--marge) * 2);
  }

}
</style>